import { ethers } from "ethers";
import { simpleRpcProvider } from "../config/chains";
import { BALANCE_ADDR, MULTICALL_ADDR, NFT_ADDR } from "../config/contracts";

import MultiCallABI from "../config/abis/MultiCallABI.json";
import ERC20ABI from "../config/abis/ERC20ABI.json";
import NFTABI from "../config/abis/NFTABI.json";
import BalanceABI from "../config/abis/BalanceABI.json";

export const getContract = (abi, address, signer, chainID) => {
  const signerOrProvider = signer ?? simpleRpcProvider(chainID);
  return new ethers.Contract(address, abi, signerOrProvider);
};

export const getErc20TokenContract = (address, signer, chainID = 1) => {
  return getContract(ERC20ABI, address, signer, chainID);
};

export const getNFTContract = (signer, chainID = 1) => {
  return getContract(NFTABI, NFT_ADDR[chainID], signer, chainID);
};

export const getMulticallContract = (signer, chainID = 1) => {
  return getContract(MultiCallABI, MULTICALL_ADDR[chainID], signer, chainID);
};

export const getBalanceContract = (signer, chainID = 1) => {
  return getContract(BalanceABI, BALANCE_ADDR[chainID], signer, chainID);
};

export const multicall = async (abi, calls, chainID = 1) => {
  const itf = new ethers.utils.Interface(abi);
  const multi = getMulticallContract(null, chainID);
  const calldata = calls.map((call) => [
    call.address.toLowerCase(),
    itf.encodeFunctionData(call.name, call.params),
  ]);

  const { returnData } = await multi.aggregate(calldata);
  const res = returnData.map((call, i) =>
    itf.decodeFunctionResult(calls[i].name, call)
  );

  return res;
};
